import { formatBRL } from "../utils/helpers";

const Products = ({ product, deleteProduct }) => {
  return (
    // <div key={product.id} className='bg-gray-50 p-1 mb-2 flex flex-col md:flex-row justify-between rounded-sm shadow-sm hover:shadow-blue-600'>
    //     <div className='ps-0 md:ps-3 flex items-center justify-center md:justify-start'>{product.name} - {formatBRL(product.price)}</div>
    //     <div className='mt-3 md:mt-0 flex items-center justify-center md:justify-end'>
    //         <button onClick={()=>{deleteProduct(product.id)}} className='bg-gray-300 hover:bg-gray-400 px-3 py-0.5 rounded-xl shadow-sm hover:cursor-pointer'>Remover</button>
    //     </div>
    // </div>
    <div key={product.id} className='bg-gray-50 p-1 mb-2 grid grid-cols-1 sm:grid-cols-3 rounded-sm shadow-sm hover:shadow-blue-600 '>
        <div className='ps-0 sm:ps-3 text-center sm:text-start'>{product.name}</div>
        <div className='text-center'>{formatBRL(product.price)}</div>
        <div className='text-center sm:text-end'>
            <button onClick={()=>{deleteProduct(product.id)}} className='bg-gray-300 hover:bg-gray-400 px-3 py-0.5 rounded-xl shadow-sm hover:cursor-pointer'>Remover</button>
        </div>
    </div>
  )
}

export default Products